/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1TutoraiConfigMemory202,
  PutApiV1TutoraiConfigMemory400,
  PutApiV1TutoraiConfigMemory401,
  PutApiV1TutoraiConfigMemory500,
  PutApiV1TutoraiConfigMemoryMutationRequest,
  PutApiV1TutoraiConfigMemoryMutationResponse,
} from "../../types/tutorAIConfigController/PutApiV1TutoraiConfigMemory.ts";
import { tutorAISetPromptConfigViewModelSchema } from "../tutorAISetPromptConfigViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1TutoraiConfigMemory202Schema =
  z.any() as unknown as ToZod<PutApiV1TutoraiConfigMemory202>;

/**
 * @description Conteúdo vazio ou personId sem classStudentId.
 */
export const putApiV1TutoraiConfigMemory400Schema =
  z.any() as unknown as ToZod<PutApiV1TutoraiConfigMemory400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1TutoraiConfigMemory401Schema =
  z.any() as unknown as ToZod<PutApiV1TutoraiConfigMemory401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1TutoraiConfigMemory500Schema =
  z.any() as unknown as ToZod<PutApiV1TutoraiConfigMemory500>;

export const putApiV1TutoraiConfigMemoryMutationRequestSchema = z.lazy(
  () => tutorAISetPromptConfigViewModelSchema,
) as unknown as ToZod<PutApiV1TutoraiConfigMemoryMutationRequest>;

export const putApiV1TutoraiConfigMemoryMutationResponseSchema = z.lazy(
  () => putApiV1TutoraiConfigMemory202Schema,
) as unknown as ToZod<PutApiV1TutoraiConfigMemoryMutationResponse>;
